module.exports = __webpack_public_path__ + "static/media/loadinganimation.415c7392.gif";